/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';
import { BaseAttachmentDTO } from '@well/attachment/domain';
import { GpsMonitorisationModel } from './gps-monitorisation.model';
import { LoadingTypeModel } from './loading-type.model';

export class VehicleDTO extends JSONable {
  uuid: string | undefined;
  licensePlate: string | undefined;
  licensePlateLabel: string | undefined;
  vehicleTypeValue: string | undefined;
  description: string | undefined;
  pricePerKm: number | undefined;
  attachmentDTOS: BaseAttachmentDTO[] = [];

  vin: number | undefined;
  brand: string | undefined;
  model: string | undefined;
  color: string | undefined;
  fuelTankCapacity: number | undefined;
  gpsMonitorisation: GpsMonitorisationModel | undefined;
  company: string | undefined;
  division: string | undefined;
  costCenter: string | undefined;
  region: string | undefined;
  condition: string | undefined;

  fuelType: string | undefined;
  engineType: string | undefined;
  engineCMC: number | undefined;
  engineMaxPower: number | undefined;
  traction: string | undefined;
  gearBox: string | undefined;
  nrDoors: number | undefined;
  nrSeats: number | undefined;
  wheelbase: number | undefined;
  mixedConsumption: number | undefined;
  urbanConsumption: number | undefined;
  extraUrbanConsumption: number | undefined;
  co2Emissions: number | undefined;
  emissionsStandard: string | undefined;

  cargoLength: number | undefined;
  cargoHeight: number | undefined;
  cargoWidth: number | undefined;
  doorHeight: number | undefined;
  loadingType: LoadingTypeModel | undefined;
  lateralDoorHeight: number | undefined;
  lateralDoorWidth: number | undefined;
  backDoorHeight: number | undefined;
  backDoorWidth: number | undefined;
  usableWeight: number | undefined;
  cargoVolume: number | undefined;
  loadingMeters: number | undefined;
}
